module.exports = __webpack_public_path__ + "e006981ece118e11407fa78fe5a92aa3.mp4";